<div class="col-12" *ngIf="gridload">
  <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-9">
      <h5 class=""><i class="fa fa-search" aria-hidden="true"></i><b>&nbsp;Permit Enquiry</b>
       </h5>
    </div>
 
  </div>
  <hr>
      
        <br>
        <!-- <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
          <legend class="scheduler-border tsk-display blackcontrol">Filters</legend>
          <div class="row" style="margin:4px auto!important;padding:0px;">
            <div class="col-3" style="margin:0px!important;padding:0px!important;">
              <input type="text" class="form-control form-control-lg pull-left" [(ngModel)]="carrierName" placeholder="Enter a carrier name..." title="Carrier name to search for.">
            </div>
            <div class="col-3">
              <input type="text" class="form-control form-control-lg" [(ngModel)]="carrierNumber" placeholder="Enter an account number..." title="Account number to search for.">
            </div>
            <div class="col-4 resizer">
              <ng-multiselect-dropdown [placeholder]="'Select one or more statuses...'"
                                       [data]="statusesFilter"
                                       [(ngModel)]="selectedItems"
                                       [settings]="dropdownSettings"
                                       (onSelect)="onItemSelect($event)"
                                       (onDeSelect)="onDeSelect($event)"
                                       (onSelectAll)="onSelectAll($event)">
              </ng-multiselect-dropdown>
            </div>
        
            <div class="col-2 btn-show" style="width:80px!important;margin:0px!important;padding:0px!important;">
              <span (click)="onReset()" title="Reset filters..." class="btn btn-success btn-md pull-right" ><i class="fa fa-undo" aria-hidden="true"></i></span>
              <span title="Apply filters..." (click)="onSearch()" class="btn btn-primary btn-md pull-right" style="margin-right:4px!important;"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
          </div>
        </fieldset> -->

        <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
          <legend class="scheduler-border tsk-display">Filters</legend>
          <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important;">
            <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
              <table class="" style="width:100%!important;margin:0px;padding:0px;" border="0">
                <tr class="rmp-all">
                  <td style="width:8%!important;vertical-align:top!important;">
                    <div class="filter-item">
                      <input type="text" class="form-control pull-left"  placeholder="Carrier..." title="Carrier name/number to search for." [(ngModel)]="carrierName" name="carrierName" value="" (keypress)="checkKey($event)"/>
                    </div>
                  </td>
                  <td style="vertical-align:top!important;width:12%!important;">
                      <!-- <div class="col-4 rmp-all-c text-right" style="">Expiry From :&nbsp;</div> -->
                      <div class="filter-item">
                        <input type="date" style="margin:0px;padding:0px;" class="form-control" title="Expiry Date From" [ngModel]="dateFrom" min="{{formattedDate | date:'yyyy-MM-dd'}}" (ngModelChange)="dateFrom = $event" name="dateFrom" class="form-control form-control-sm" />
                      </div>
                  </td>
                  <td style="vertical-align:top!important;width:12%!important;" class="">
                    <div class="filter-item">
                        <input type="date" [ngModel]="dateTo" class="form-control" title="Expiry Date To" (ngModelChange)="dateTo = $event" name="dateTo" min="{{formattedDate | date:'yyyy-MM-dd'}}" class="form-control form-control-sm" />
                    </div>
                  </td>
                  <td style="vertical-align:top!important;width:10%!important;" class="">
                    <div class="filter-item">
                        <ng-multiselect-dropdown [placeholder]="'Statuses...'" 
                                       [data]="statusesFilter"
                                       [(ngModel)]="selectedItems"
                                       [settings]="dropdownSettings"
                                       (onSelect)="onItemSelect($event)"
                                       (onDeSelect)="onDeSelect($event)"
                                       (onSelectAll)="onSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div> 
                  </td>
                  <td style="width:9%!important;vertical-align:top!important;">
                    <!-- <select title="Select Active/Inactive indicator..." class="form-control">
                    </select> -->
                    <div class="filter-item">
                      <ng-multiselect-dropdown [placeholder]="'Indicator...'" 
                                       [data]="actives"
                                       [(ngModel)]="activeItems"
                                       [settings]="activeSettings"
                                       (onSelect)="onActiveItemSelect($event)"
                                       (onDeSelect)="onActiveDeSelect($event)"
                                       (onSelectAll)="onActiveSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </td>
                  <td style="width:5%!important;vertical-align:top!important;">
                    <b>Permit type:</b>
                  </td>
                  <td style="width:5%!important;vertical-align:top!important;">
                    <div class="filter-item">
                    <select title="Select permit type..." class="form-control" [(ngModel)]="permit_type">
                        <option *ngFor="let cat of types" [value]="cat.id">{{cat.description}}</option>
                    </select>
                  </div>
                  </td>
                  <td style="width:8%!important;vertical-align:top!important;">
                    <input title="Enter permit number..." placeholder="Permit Number" class="form-control"  [(ngModel)]="permit_num" (keypress)="checkKey($event)">
                  </td>
                  <td style="width:8%!important;vertical-align:top!important;">
                    <input title="Enter vehicle registration number..." placeholder="Vehicle registration number" class="form-control" [(ngModel)]="vehicle_num" (keypress)="checkKey($event)">
                  </td>

                   
                              
                  <td style="vertical-align:top!important;width:10%!important;" class="rmp-all">
                    <!--Button with tooltip and no label -->
                    <div class="cover-x pull-right">
                      <div class="main-btn rounded-circle rmp-all" (click)="reset()" title="Reset filters..." style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                        <span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                      </div>
                    </div>
                    <div class="cover-x">
                      <div class="main-btn rounded-circle rmp-all" (click)="onSearch()" title="Apply filters..." style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                        <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </fieldset>


<style>
.filter-item {
    height: 38px; /* You can adjust the height as needed */
    margin-bottom: 4px; /* Optional spacing between items */
  }  
</style>


          <div class="row">
            <div class="col-md-12">
              <!-- <ngx-loading [show]="gridload"></ngx-loading> -->

              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th rowspan="2" style="min-width:100px !important;">Account Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(1)"></i></th>
                    <th rowspan="2"  title="permit type description">Permit Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>
                   
                    <th rowspan="2">Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                    <th rowspan="2">Start<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(4)"></i></th>
                    <th rowspan="2"></th>
                    <th rowspan="2">End<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(5)"></i></th>
                    <th rowspan="2">Status<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(6)"></i></th>
                 <!--   <th colspan="2">Vehicle</th>-->
                    <th rowspan="2">Vehicle Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th>
                    <th rowspan="2">Registration No<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <!-- <th rowspan="2"> Dropdown Menu</th> -->
                  </tr>
                  <tr>
                    <!-- <th>Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <th>Registration<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th> -->
                  </tr>
                  
                </thead>
                <tbody>
                  <tr
                  *ngFor="let item of permits | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                  <ng-container>
                    <td title="{{item.Name}}">
                      <a [routerLink]="['/carrier/account/edit/' + item.carrier.id + '/1' ]" style="color:#00008b; text-decoration: underline;"><span title ="View account details">{{item.AccountNumber}}</span></a>  
                    </td>
                  <td>
                    <div class="row" *ngFor="let perm of item.Permit">
                      <a  [routerLink]="['/carrier/permit/application/view/' + perm.application_id + '/' + perm.permit_issue]" style="color:#00008b; text-decoration: underline;">
                        <span title ="View permit details">
                        {{perm.permit_num}} /
                        {{perm.permit_issue}}                    
                      </span>
                    </a>      
                  </div>              
                  </td>
                   
                    <td  title="{{item.PermitType}}">
                      <div class="row">
                        <span>
                          {{item.PermitType}}
                        </span>
                      </div>
                    </td>
                    <td >
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span *ngIf="perm.date_valid_from!=null">{{perm.date_valid_from | date:'dd/MM/yyyy'}}</span>
                      </div>
                    </td>
                    <td>&nbsp;</td>
                    <td>
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span *ngIf="perm.date_valid_to!=null">{{perm.date_valid_to | date:'dd/MM/yyyy'}}</span>
                      </div>
                    </td>
                    <td ><span *ngIf="item.status_id!=null">{{item.status}}</span></td>
                    <td >
                      <div class="row" *ngFor="let perm of item.Permit">
                         <span>{{perm.vehicle_type}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="row" *ngFor="let perm of item.Permit">
                        <span>{{perm.vehicle_reg_num}}</span>
                      </div>
                    </td>
                   
                   
                    <!-- <td ><span *ngIf="item.Route!=null">{{item.Route.code}}</span></td>
                    <td><span *ngIf="item.submission_date!=null">{{item.submission_date | date:'dd/MM/yyyy'}}
                    </span>
                    </td> -->
                  </ng-container>
                    <!-- <td>
                        <select class="form-control" (change)="navigatePermit(item,change)" id="selectControl" #change>
                            <option value="">Select</option>
                            <option class="app-option" disabled value="myNum">Duplicate</option>
                            <option class="app-option" disabled value="myNum">Change Owner</option>
                            <option class="app-option" disabled value="myNum">Change Route</option>
                            <option class="app-option" disabled value="myNum">Change Timetable</option>
                            <option class="app-option" disabled value="myNum">Change Vehicle</option>
                            <option class="app-option" disabled value="myNum">Upload Passenger Lists</option>
                            <option class="app-option" disabled value="myNum">Upload Consignment Notes</option>
                            <option value="renew" *ngIf="item.status_id!=1 && item.status_id!=11 && item.listRes.permit_type.temp_long_ind==2 && item.listRes.permit.is_valid">Renew Permit</option>
                            
                            
                        </select>
                    </td> -->
                  </tr> 
                </tbody>
              </table>
              <p class="use-mouse">Use your mouse to hover over a code to see the description</p>
              <div style="text-align:center" *ngIf="Count >= 5">
                <table border="0" cellpadding="0" cellspacing="0" style="float: right;">
                  <tr>
                    <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                      Show :
                    </td>
                    <td style="white-space: nowrap">
                      <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                        <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                      </select>
                    </td>
                  </tr>
                </table>
                <pagination-controls class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>            
              </div>

              <div>
                <tfoot>
                  <tr *ngIf="isEmpty">
                    <td colspan="9" class="rm-brd">
                      <span class="text-info text-small; color:black">No permits found.</span>
                    </td>
                  </tr>

                </tfoot>

              </div>
              <!--<div style="text-align:center" *ngIf="permits.length <= 0">
                <h5>no permits found</h5>
              </div>-->
            </div>         
          </div>
    <div>
        <!-- <div class="card-data">
            <div class="col-md-12">
                <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary pull-right" style="margin-left:10px; ">Back</button>
              </div>
        </div> -->
    </div>
</div>